<template>
  <mobile-responsive-shell :title="title">
    <div v-if="payment && payment.reference" class="pay-d">
      <div class="pay-d-actions">
        <button v-if="$userRole == 'Admin'" type="button" class="btn btn-sm btn-outline-secondary" @click="refresh">
          <i class="bi bi-check2-square"></i> Valider
        </button>
        <button
          v-if="payment.reference && $userRole == 'Admin'"
          type="button"
          class="btn btn-sm btn-outline-primary"
          @click="$router.push({ name: 'mobile-payments-customers-edit', params: { reference: payment.reference } })"
        >
          <i class="bi bi-pencil-square"></i> Modifier
        </button>
        <button v-if="payment.reference" type="button" class="btn btn-sm btn-outline-secondary" @click="print(payment.reference)">
          <i class="bi bi-printer"></i>
        </button>
        <button
          v-if="payment.reference && userRole == 'Admin'"
          type="button"
          class="btn btn-sm btn-outline-danger"
          @click="remove(payment.reference)"
        >
          <i class="bi bi-trash"></i>
        </button>
        <button type="button" class="btn btn-sm btn-outline-secondary" @click="refresh">
          <i class="bi bi-arrow-clockwise"></i>
        </button>
      </div>

      <p class="text-muted small mb-2">Réf. <strong>{{ payment.reference }}</strong></p>

      <section class="pay-d-card">
        <h3 class="pay-d-h">Client</h3>
        <dl class="pay-kv">
          <div>
            <dt>Nom</dt>
            <dd>
              <span
                v-if="payment.customer"
                :class="payment.customer.fullName && payment.customer.fullName.includes('Bloqué') ? 'text-danger' : ''"
              >
                {{ payment.customer.fullName }}
              </span>
              <span v-else>—</span>
            </dd>
          </div>
          <div><dt>Téléphone</dt><dd>{{ payment.customer ? payment.customer.phone : "—" }}</dd></div>
          <div><dt>Société</dt><dd>{{ payment.customer ? payment.customer.society : "—" }}</dd></div>
        </dl>
      </section>

      <section class="pay-d-card">
        <h3 class="pay-d-h">Paiement</h3>
        <dl class="pay-kv">
          <div><dt>Montant</dt><dd class="text-success fw-semibold">{{ payment.amount | toFixedWithSpace }} Dh</dd></div>
          <div><dt>En lettres</dt><dd class="text-uppercase">{{ payment.writtenAmount || "—" }}</dd></div>
          <div><dt>Impayé</dt><dd class="text-danger">{{ payment.remainingAmount | toFixedWithSpace }}</dd></div>
          <div><dt>Mode</dt><dd>{{ payment.paymentMethod || "—" }}</dd></div>
          <div><dt>Nº chèque</dt><dd>{{ payment.checkNumber || "—" }}</dd></div>
          <div><dt>Nº virement</dt><dd>{{ payment.bankTransferNumber || "—" }}</dd></div>
          <div>
            <dt>Validé</dt>
            <dd :class="payment.validated ? 'text-success' : 'text-warning'">{{ payment.validated ? "Oui" : "En attente" }}</dd>
          </div>
        </dl>
      </section>

      <section v-if="payment.remark" class="pay-d-card">
        <h3 class="pay-d-h">Remarque</h3>
        <p class="mb-0 small">{{ payment.remark }}</p>
      </section>

      <section class="pay-d-card">
        <h3 class="pay-d-h">Lignes (BL / factures)</h3>
        <p v-if="!lineRows.length" class="text-muted mb-0">Aucune ligne.</p>
        <article v-for="(ps, idx) in lineRows" :key="idx" class="pay-line">
          <div class="fw-semibold">{{ ps.sale_reference }}</div>
          <dl class="pay-kv pay-kv--compact mt-1 mb-0">
            <div><dt>Date</dt><dd>{{ ps.date }}</dd></div>
            <div>
              <dt>M. facture</dt>
              <dd>
                <span v-if="ps.sale && ps.sale.totalPriceTTC >= 0">{{ ps.sale.totalPriceTTC }}</span>
                <span v-else>—</span>
              </dd>
            </div>
            <div><dt>Payé</dt><dd class="text-success">{{ ps.amount | toFixedWithSpace }}</dd></div>
            <div><dt>Impayé</dt><dd class="text-danger">{{ ps.remainingAmount | toFixedWithSpace }}</dd></div>
            <div v-if="ps.user"><dt>Par</dt><dd>{{ ps.user.name }}</dd></div>
          </dl>
        </article>
      </section>
    </div>
    <p v-else class="text-muted text-center py-4">Chargement…</p>
  </mobile-responsive-shell>
</template>

<script>
import { mapGetters } from "vuex";
import MobileResponsiveShell from "../components/MobileResponsiveShell.vue";

export default {
  name: "MobilePaymentsCustomersDetails",
  components: { MobileResponsiveShell },
  computed: {
    ...mapGetters("payment", { payment: "getPayment" }),
    ...mapGetters("auth", { userRole: "getUserRole" }),
    title() {
      const r = this.$route.params.reference;
      return r ? "Paiement " + r : "Détail paiement";
    },
    lineRows() {
      const rows = this.payment && this.payment.payment_sales;
      return Array.isArray(rows) ? rows : [];
    },
  },
  mounted() {
    this.$store.dispatch("payment/show", this.$route.params.reference);
  },
  methods: {
    async refresh() {
      await this.$store.dispatch("payment/show", this.$route.params.reference);
    },
    async remove(reference) {
      await this.$store.dispatch("payment/destroy", reference);
    },
    async print(reference) {
      await this.$store.dispatch("payment/printReceipt", reference);
    },
  },
  filters: {
    toFixedWithSpace: (value) => {
      if (value === undefined || value === null || value === "") return "—";
      return parseFloat(value)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
    },
  },
};
</script>

<style scoped>
.pay-d-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
}
.pay-d-card {
  background: #fff;
  border-radius: 12px;
  padding: 0.875rem 1rem;
  margin-bottom: 0.75rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.pay-d-h {
  font-size: 0.85rem;
  font-weight: 700;
  margin: 0 0 0.5rem;
  color: #495057;
}
.pay-kv {
  margin: 0;
  display: grid;
  gap: 0.35rem;
}
.pay-kv > div {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  font-size: 0.9rem;
}
.pay-kv dt {
  margin: 0;
  color: #6c757d;
  font-weight: 500;
}
.pay-kv dd {
  margin: 0;
  text-align: right;
  word-break: break-word;
}
.pay-kv--compact > div {
  font-size: 0.85rem;
}
.pay-line {
  padding: 0.65rem 0;
  border-bottom: 1px solid #eee;
}
.pay-line:last-child {
  border-bottom: none;
}
</style>
